"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PetLiquidTimeAllyPetFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var PetLiquidTimeAllyPetFactory = /** @class */ (function (_super) {
    __extends(PetLiquidTimeAllyPetFactory, _super);
    function PetLiquidTimeAllyPetFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    PetLiquidTimeAllyPetFactory.prototype.deploy = function (_prepaidEs, _nrtManager, overrides) {
        return _super.prototype.deploy.call(this, _prepaidEs, _nrtManager, overrides || {});
    };
    PetLiquidTimeAllyPetFactory.prototype.getDeployTransaction = function (_prepaidEs, _nrtManager, overrides) {
        return _super.prototype.getDeployTransaction.call(this, _prepaidEs, _nrtManager, overrides || {});
    };
    PetLiquidTimeAllyPetFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    PetLiquidTimeAllyPetFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    PetLiquidTimeAllyPetFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return PetLiquidTimeAllyPetFactory;
}(contracts_1.ContractFactory));
exports.PetLiquidTimeAllyPetFactory = PetLiquidTimeAllyPetFactory;
var _abi = [
    {
        inputs: [
            {
                internalType: 'contract PrepaidEs',
                name: '_prepaidEs',
                type: 'address',
            },
            {
                internalType: 'contract INRTManager',
                name: '_nrtManager',
                type: 'address',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'constructor',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: '_staker',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'uint256',
                name: '_petId',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: '_fromMonthId',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: '_toMonthId',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: '_withdrawlAmount',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'address',
                name: '_withdrawnBy',
                type: 'address',
            },
        ],
        name: 'AnnuityWithdrawl',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: '_staker',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'uint256',
                name: '_petId',
                type: 'uint256',
            },
            {
                indexed: true,
                internalType: 'address',
                name: '_appointeeAddress',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'bool',
                name: '_appointeeStatus',
                type: 'bool',
            },
        ],
        name: 'AppointeeUpdated',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: '_staker',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'uint256',
                name: '_petId',
                type: 'uint256',
            },
            {
                indexed: true,
                internalType: 'address',
                name: '_appointeeAddress',
                type: 'address',
            },
        ],
        name: 'AppointeeVoted',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'address',
                name: '_staker',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: '_petId',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: '_burningAmount',
                type: 'uint256',
            },
        ],
        name: 'BoosterBurn',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: '_staker',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'uint256',
                name: '_petId',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: '_monthId',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: '_depositAmount',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'address',
                name: '_depositedBy',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'bool',
                name: '_usingPrepaidES',
                type: 'bool',
            },
        ],
        name: 'NewDeposit',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: '_staker',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: '_petId',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: '_monthlyCommitmentAmount',
                type: 'uint256',
            },
        ],
        name: 'NewPET',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'uint256',
                name: '_minimumMonthlyCommitmentAmount',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: '_monthlyBenefitFactorPerThousand',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: '_petPlanId',
                type: 'uint256',
            },
        ],
        name: 'NewPETPlan',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: '_staker',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'uint256',
                name: '_petId',
                type: 'uint256',
            },
            {
                indexed: true,
                internalType: 'address',
                name: '_nomineeAddress',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'bool',
                name: '_nomineeStatus',
                type: 'bool',
            },
        ],
        name: 'NomineeUpdated',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'previousOwner',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'newOwner',
                type: 'address',
            },
        ],
        name: 'OwnershipTransferred',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: '_staker',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'uint256',
                name: '_petId',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: '_powerBoosterId',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: '_withdrawlAmount',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'address',
                name: '_withdrawnBy',
                type: 'address',
            },
        ],
        name: 'PowerBoosterWithdrawl',
        type: 'event',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_stakerAddress',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: '_petId',
                type: 'uint256',
            },
        ],
        name: 'appointeeVote',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_stakerAddress',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: '_petId',
                type: 'uint256',
            },
        ],
        name: 'calculatePowerBoosterAmount',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_minimumMonthlyCommitmentAmount',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: '_monthlyBenefitFactorPerThousand',
                type: 'uint256',
            },
        ],
        name: 'createPETPlan',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'deployer',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'fundsBucket',
        outputs: [
            {
                internalType: 'contract FundsBucket',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_stakerAddress',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: '_petId',
                type: 'uint256',
            },
        ],
        name: 'getDepositMonth',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_stakerAddress',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: '_petId',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: '_monthId',
                type: 'uint256',
            },
        ],
        name: 'getMonthlyDepositedAmount',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_stakerAddress',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: '_petId',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: '_annuityMonthId',
                type: 'uint256',
            },
        ],
        name: 'getNomineeAllowedTimestamp',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_stakerAddress',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: '_petId',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: '_startAnnuityMonthId',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: '_endAnnuityMonthId',
                type: 'uint256',
            },
        ],
        name: 'getSumOfMonthlyAnnuity',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'isAdminMode',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_stakerAddress',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: '_petId',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: '_depositAmount',
                type: 'uint256',
            },
            {
                internalType: 'bool',
                name: '_usePrepaidES',
                type: 'bool',
            },
        ],
        name: 'makeDeposit',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_stakerAddress',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: '_petId',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: '_totalDepositAmount',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: '_frequencyMode',
                type: 'uint256',
            },
            {
                internalType: 'bool',
                name: '_usePrepaidES',
                type: 'bool',
            },
        ],
        name: 'makeFrequencyModeDeposit',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_stakerAddress',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: '_petId',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: '_depositAmount',
                type: 'uint256',
            },
            {
                internalType: 'bool',
                name: '_usePrepaidES',
                type: 'bool',
            },
            {
                internalType: 'uint256',
                name: '_depositMonth',
                type: 'uint256',
            },
        ],
        name: 'migrateDeposit',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_planId',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: '_monthlyCommitmentAmount',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: '_timestamp',
                type: 'uint256',
            },
        ],
        name: 'migratePET',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_planId',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: '_monthlyCommitmentAmount',
                type: 'uint256',
            },
        ],
        name: 'newPET',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'nrtManager',
        outputs: [
            {
                internalType: 'contract INRTManager',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'owner',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        name: 'petPlans',
        outputs: [
            {
                internalType: 'bool',
                name: 'isPlanActive',
                type: 'bool',
            },
            {
                internalType: 'uint256',
                name: 'minimumMonthlyCommitmentAmount',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'monthlyBenefitFactorPerThousand',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        name: 'pets',
        outputs: [
            {
                internalType: 'uint256',
                name: 'planId',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'monthlyCommitmentAmount',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'initTimestamp',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'lastAnnuityWithdrawlMonthId',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'appointeeVotes',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'numberOfAppointees',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'prepaidEs',
        outputs: [
            {
                internalType: 'contract PrepaidEs',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'renounceAdminMode',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_petId',
                type: 'uint256',
            },
            {
                internalType: 'address',
                name: '_appointeeAddress',
                type: 'address',
            },
            {
                internalType: 'bool',
                name: '_newAppointeeStatus',
                type: 'bool',
            },
        ],
        name: 'toogleAppointee',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_petId',
                type: 'uint256',
            },
            {
                internalType: 'address',
                name: '_nomineeAddress',
                type: 'address',
            },
            {
                internalType: 'bool',
                name: '_newNomineeStatus',
                type: 'bool',
            },
        ],
        name: 'toogleNominee',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'newOwner',
                type: 'address',
            },
        ],
        name: 'transferOwnership',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_planId',
                type: 'uint256',
            },
            {
                internalType: 'bool',
                name: '_newStatus',
                type: 'bool',
            },
        ],
        name: 'updatePlanStatus',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_stakerAddress',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: '_petId',
                type: 'uint256',
            },
            {
                internalType: 'address',
                name: '_appointeeAddress',
                type: 'address',
            },
        ],
        name: 'viewAppointation',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_stakerAddress',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: '_petId',
                type: 'uint256',
            },
            {
                internalType: 'address',
                name: '_nomineeAddress',
                type: 'address',
            },
        ],
        name: 'viewNomination',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_stakerAddress',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: '_petId',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: '_endAnnuityMonthId',
                type: 'uint256',
            },
        ],
        name: 'withdrawAnnuity',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_stakerAddress',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: '_petId',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: '_powerBoosterId',
                type: 'uint256',
            },
        ],
        name: 'withdrawPowerBooster',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        stateMutability: 'payable',
        type: 'receive',
    },
];
var _bytecode = '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';
//# sourceMappingURL=PetLiquidTimeAllyPetFactory.js.map